export default "__VITE_ASSET__AgqXvhw___"